import React, { useMemo } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import Chart from 'react-apexcharts';

const UnconstrainedForecastChart = ({ data: incomingData, productName }) => {
  const payload = useMemo(() => incomingData || { dates: [], series: [], presentIso: null, lastIso: null }, [incomingData]);
  const chartTitle = productName
    ? `UNCONSTRAINED VS DRIVER ADJUSTED FORECAST (${productName}™)`
    : 'UNCONSTRAINED VS DRIVER ADJUSTED FORECAST';

  const xaxis = {
    type: 'datetime',
    categories: payload.dates || [],
    labels: { rotate: -45, datetimeUTC: false },
    tickAmount: 8,
  };

  if (payload.startDate) xaxis.min = new Date(payload.startDate).getTime();
  if (payload.endDate) xaxis.max = new Date(payload.endDate).getTime();

  const seriesCount = (payload.series || []).length;
  const options = {
    chart: {
      type: 'line',
      height: 300,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    colors: ['#9e9e9e', '#005587', '#00A3E0'].slice(0, seriesCount),
    stroke: {
      width: Array(seriesCount).fill(2),
      // Historical solid, Constrained dashed, Unconstrained solid
      dashArray: seriesCount >= 3 ? [0, 6, 0] : Array(seriesCount).fill(0),
    },
    markers: { size: 3 },
    xaxis,
    yaxis: {
      title: {
        text: 'Units',
        rotate: -90,
        offsetX: 0,
        style: {
          color: '#5f6368',
          fontSize: '10px',
          fontWeight: 600,
        },
      },
      labels: { formatter: (val) => (val ? Math.round(val).toLocaleString() : '0') },
    },
    tooltip: { shared: true, x: { format: 'MMM yyyy' } },
    legend: { position: 'top' },
    annotations: {
      xaxis: payload.presentIso
        ? [
            {
              x: payload.presentIso,
              borderColor: '#bdbdbd',
              label: { text: 'Now', style: { color: '#333' } },
            },
            ...(payload.lastIso
              ? [{
                  x: payload.presentIso,
                  x2: payload.lastIso,
                  fillColor: '#f4f6f8',
                  opacity: 0.5,
                }]
              : []),
          ]
        : [],
    },
    grid: { show: true, borderColor: '#f0f2f5' },
  };

  const series = (payload.series || []).map((s) => ({ name: s.name, data: s.data }));

  return (
    <Paper elevation={0} sx={{ borderRadius: 2, p: 1, border: '1px solid #e8eaed', width: '100%' }}>
      <Box sx={{ px: 1, pb: 1 }}>
        <Typography sx={{ fontWeight: 700, color: '#2B3A42', fontSize: '13px', mb: 0.5 }}>{chartTitle}</Typography>
      </Box>
      <Box sx={{ width: '100%' }}>
        <Chart options={options} series={series} type="line" height={300} />
      </Box>
    </Paper>
  );
};

export default UnconstrainedForecastChart;
